import createIcon from '../../createIcon';

/**
 * @component @name Sixteenmp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSA5SDE1VjEwLjVIMTMuNVY5Wk0xOSAzSDVDMy45IDMgMyAzLjkgMyA1VjE5QzMgMjAuMSAzLjkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTEyIDE4LjVIMTAuNVYxNEg5LjVWMTdIOFYxNEg3VjE4LjVINS41VjEzLjVDNS41IDEyLjk1IDUuOTUgMTIuNSA2LjUgMTIuNUgxMUMxMS41NSAxMi41IDEyIDEyLjk1IDEyIDEzLjVWMTguNVpNMTUuNSAxOC41SDE0VjEyLjVIMTcuNUMxOC4wNSAxMi41IDE4LjUgMTIuOTUgMTguNSAxMy41VjE2QzE4LjUgMTYuNTUgMTguMDUgMTcgMTcuNSAxN0gxNS41VjE4LjVaTTEwIDUuNVYxMS41SDguNVY3SDdWNS41SDEwWk0xMyAxMS41QzEyLjQ1IDExLjUgMTIgMTEuMDUgMTIgMTAuNVY2LjVDMTIgNS45NSAxMi40NSA1LjUgMTMgNS41SDE2LjVWN0gxMy41VjhIMTUuNUMxNi4wNSA4IDE2LjUgOC40NSAxNi41IDlWMTAuNUMxNi41IDExLjA1IDE2LjA1IDExLjUgMTUuNSAxMS41SDEzWk0xNS41IDE0SDE3VjE1LjVIMTUuNVYxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sixteenmp = createIcon('Sixteenmp', [
  [
    'path',
    {
      d: 'M13.5 9H15V10.5H13.5V9ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 18.5H10.5V14H9.5V17H8V14H7V18.5H5.5V13.5C5.5 12.95 5.95 12.5 6.5 12.5H11C11.55 12.5 12 12.95 12 13.5V18.5ZM15.5 18.5H14V12.5H17.5C18.05 12.5 18.5 12.95 18.5 13.5V16C18.5 16.55 18.05 17 17.5 17H15.5V18.5ZM10 5.5V11.5H8.5V7H7V5.5H10ZM13 11.5C12.45 11.5 12 11.05 12 10.5V6.5C12 5.95 12.45 5.5 13 5.5H16.5V7H13.5V8H15.5C16.05 8 16.5 8.45 16.5 9V10.5C16.5 11.05 16.05 11.5 15.5 11.5H13ZM15.5 14H17V15.5H15.5V14Z',
      key: 'o1hr5t',
    },
  ],
]);

export default Sixteenmp;
